(() => {
  if (window.__rylNavigationCurrentLoaded) return;
  window.__rylNavigationCurrentLoaded = true;

  const sectionKeys = [
    ['ryl-find-collections', 'shop'],
    ['ryl-shop', 'shop'],
    ['ryl-create', 'create'],
    ['ryl-work', 'work'],
    ['ryl-learn-resources', 'learn'],
    ['ryl-barn-immersive', 'regulate'],
    ['ryl-empower-content', 'lift'],
    ['ryl-about', 'about'],
    ['ryl-connect', 'contact']
  ];
  const navSelector = '.ryl-primary-nav__link, .ryl-home-menu-link, .ryl-home-bar-link, .ryl-home-mobile-link';

  const navLinks = () => Array.from(document.querySelectorAll(navSelector));
  const sections = sectionKeys
    .map(([id, key]) => ({ section: document.getElementById(id), key }))
    .filter(({ section }) => Boolean(section));

  function setCurrent(key) {
    navLinks().forEach((link) => {
      const isCurrent = link.dataset.rylNavKey === key || link.getAttribute('href')?.endsWith(`#${key}`);
      link.classList.toggle('ryl-nav-is-current', Boolean(isCurrent));
      if (isCurrent) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  }

  function updateFromPath() {
    const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    const matchingLink = navLinks().find((link) => {
      const url = new URL(link.href, window.location.origin);
      const linkPath = url.pathname.replace(/\/$/, '') || '/';
      return linkPath === currentPath && linkPath !== '/';
    });
    if (matchingLink?.dataset.rylNavKey) setCurrent(matchingLink.dataset.rylNavKey);
  }

  function updateFromViewport() {
    if (!sections.length) {
      updateFromPath();
      return;
    }
    const marker = Math.max(120, window.innerHeight * 0.24);
    let current = null;
    for (const { section, key } of sections) {
      const rect = section.getBoundingClientRect();
      if (rect.top <= marker && rect.bottom > marker) current = key;
    }
    if (current) setCurrent(current);
    else updateFromPath();
  }

  let ticking = false;
  const schedule = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      updateFromViewport();
      ticking = false;
    });
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('hashchange', schedule);
  schedule();
})();
